export const regionCountryMap = {
    "MY": "Malaysia",
    "SG": "Singapore",
    "BN": "Brunei",
    "AU": "Australia",
    "NZ": "New Zealand"
    };

export const countryCodes = [
    { value: "+60", label: "+60 (Malaysia)" },
    { value: "+65", label: "+65 (Singapore)" },
    { value: "+62", label: "+62 (Indonesia)" },
    { value: "+66", label: "+66 (Thailand)" },
    { value: "+63", label: "+63 (Philippines)" },
    { value: "+84", label: "+84 (Vietnam)" },
    { value: "+1", label: "+1 (US/Canada)" },
    { value: "+44", label: "+44 (UK)" },
    { value: "+61", label: "+61 (Australia)" },
    { value: "+86", label: "+86 (China)" },
    { value: "+91", label: "+91 (India)" },
    { value: "+81", label: "+81 (Japan)" },
    { value: "+82", label: "+82 (South Korea)" },
    { value: "+852", label: "+852 (Hong Kong)" },
    { value: "+853", label: "+853 (Macau)" },
  ];

export const language_options = [
    "English",
    "Bahasa Malaysia",
    "Mandarin",
    "Tamil",
    "Hokkien",
    "Cantonese",
];